module.exports = __webpack_public_path__ + "static/media/kid-juicing-lemon.afc75d8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-juicing-lemon.jpg
// module id = 805
// module chunks = 0